import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const PatOcorrencias = ({ dadosPat }) => {
  const { request, data, errors } = useApiClient();
  const [rowOcorrencias, setrowOcorrencias] = useState();

  const requestOcorrenciasHandler = useCallback(() => {
    if (dadosPat.sqProcesso !== "" || dadosPat.sqProcesso !== undefined) {
      const values = {
        SqProcessoPat: dadosPat.sqProcesso,
        pageSize: 25,
        pageNumber: 1,
      };

      request(apiRoutes.fiscalizacao.ordemservico.patOcorrenciasOs, values);
    }
  }, [request, dadosPat.sqProcesso]);

  useEffect(() => {
    requestOcorrenciasHandler();
  }, [requestOcorrenciasHandler]);

  useEffect(() => {
    if (!data && !errors) return;

    if (data) {
      setrowOcorrencias(data.result);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);

  return (
    <div style={{ width: "100%" }}>
      {rowOcorrencias?.length > 0 ? (
        rowOcorrencias.map((item) => {
          const itemOcorrencias = (
            <>
              <Row style={{ margin: 10, textAlign: "left" }}>
                <Col sm="1">
                  <strong>{item.linha} - </strong>
                </Col>
                <Col sm="11">
                  <strong>Descrição: </strong>
                  <br />
                  <span>{item.dsOcorrencia}</span>
                </Col>
              </Row>
              <Row style={{ margin: 10, textAlign: "left" }}>
                <Col sm="1">
                  <strong> </strong>
                </Col>
                <Col sm="11">
                  <strong>Infringência: </strong>
                  <br />
                  <span>{item.txInfrigencia}</span>
                </Col>
              </Row>
              <Row style={{ margin: 10, textAlign: "left" }}>
                <Col sm="1">
                  <strong> </strong>
                </Col>
                <Col sm="11">
                  <strong>Penalidade: </strong>
                  <br />
                  <span>{item.txPenalidade}</span>
                </Col>
              </Row>
            </>
          );
          return itemOcorrencias;
        })
      ) : (
        <span className="m-0 font-weight-bold text-primary flex-grow-1 px-2">Nenhuma Ocorrência encontrada</span>
      )}
    </div>
  );
};
export default PatOcorrencias;
